export const getSessionData = (key) => {
    return JSON.parse(sessionStorage.getItem(key));
}
export const setSessionData = (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data));
}